import React from 'react'

import { cn } from '@app/utils'

// * ContactsTable.tsx, AccountsTable.tsx, LeadsTable.tsx
const variants = {
  button: {
    base: 'text-sm font-regular rounded-full capitalize h-[36px] pl-md pr-sm py-xs',
    active: 'bg-color-active text-color-primary',
  },
  counter: {
    base: 'text-xs font-bold ml-sm bg-gray-lightest rounded-full px-2xs py-4xs',
    active: 'bg-color-active-light',
  },
}

interface FilterButtonProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'children'> {
  label: string | React.ReactNode
  count: number
  active: boolean
}

export const FilterButton = React.forwardRef<HTMLButtonElement, FilterButtonProps>((props, ref) => {
  const { className, label: _label, count, active, ...buttonProps } = props

  let label = typeof _label === 'string' ? <span>{_label}</span> : _label

  return (
    <button className={cn(variants.button.base, active && variants.button.active, className)} {...buttonProps} ref={ref}>
      {label}
      <span className={cn(variants.counter.base, active && variants.counter.active, className)}>{count}</span>
    </button>
  )
})

FilterButton.displayName = 'FilterButton'
